<script lang="ts">
	import { formatCurrency } from './formatCurrency'
	import {
		calculateInputFromRealValue,
		calculateRealValueFromInput,
		max,
	} from './sliderValueConverter'
	import type { PricingPlanRecord } from 'datocms/models'

	interface Props {
		monthlyRevenue: number
		pricingPackages: PricingPlanRecord[]
	}

	let { monthlyRevenue = $bindable(), pricingPackages }: Props = $props()

	let linearRevenue: number = $state(calculateInputFromRealValue(monthlyRevenue))

	function handleSliderChange() {
		monthlyRevenue = calculateRealValueFromInput(linearRevenue)
	}
</script>

<div
	class="relative flex flex-col items-center gap-4 pt-7.5 max-lg:mx-6 max-lg:flex-col-reverse md:w-full lg:flex-row lg:gap-7.5"
>
	<div
		class="font-display text-h3-desktop-new-font-size font-h3-desktop-new-font-weight text-trackdesk-dark dark:text-muted relative flex items-center justify-start text-left leading-5.5"
	>
		Monthly Affiliate Revenue
	</div>
	<div class="font-display text-muted relative h-7.5 grow max-lg:w-full">
		<div class="absolute inset-0 flex h-7.5 items-center">
			<div class="bg-line h-3 w-full rounded-md"></div>
		</div>

		<div class="relative mx-4">
			{#each pricingPackages.filter((plan) => plan.revenueLimit) as plan (plan.membershipPlanId)}
				<div
					style="left: {calculateInputFromRealValue(plan.revenueLimit)}%"
					class="pointer-events-none absolute flex h-7.5 items-center"
				>
					<div class="border-muted h-6 w-0 border-l"></div>
				</div>
			{/each}

			<output
				style="left: {linearRevenue}%"
				class="font-display text-h2-desktop-new-font-size font-h2-desktop-new-font-weight text-trackdesk-green absolute bottom-full -translate-x-1/2 text-center leading-7"
			>
				{formatCurrency(
					calculateRealValueFromInput(linearRevenue),
					true,
				)}{#if max === calculateRealValueFromInput(linearRevenue)}+{/if}
			</output>
		</div>
		<input
			class="input-range relative h-7.5 w-full bg-transparent px-px"
			max={100}
			min={0}
			oninput={handleSliderChange}
			step={0.1}
			type="range"
			bind:value={linearRevenue}
		/>
	</div>
</div>

<style lang="postcss">
	.input-range,
	.input-range::-webkit-slider-runnable-track,
	.input-range::-webkit-slider-thumb {
		appearance: none;
	}

	/* some code duplication here, but it's the only way to make it work in all browsers */
	/* -moz- selectors invalidates the -webkit- selectors, when they are in the same block */
	.input-range::-webkit-slider-runnable-track {
		height: 100%;
	}

	.input-range::-moz-range-track {
		height: 100%;
	}

	.input-range::-webkit-slider-thumb {
		box-sizing: border-box;
		width: calc(var(--spacing) * 7);
		height: calc(var(--spacing) * 7);
		border-radius: 100%;
		border: 5px solid var(--color-white);
		background: var(--color-green-trackdesk);
		box-shadow: 0 0 0 1px var(--color-line);
		margin-top: 1px;
	}

	.input-range::-moz-range-thumb {
		box-sizing: border-box;
		width: calc(var(--spacing) * 7);
		height: calc(var(--spacing) * 7);
		border-radius: 100%;
		border: 5px solid var(--color-white);
		background: var(--color-green-trackdesk);
		margin-top: 1px;
		box-shadow: 0 0 0 1px var(--color-line);
	}
</style>
